var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Shape__shape___12KOE {\n  position: absolute;\n  pointer-events: none;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  z-index: 1\n}\n\n.Shape__shape___12KOE:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: 100%;\n  }\n\n.Shape__shape___12KOE.Shape__grey___3tqYF {\n  background-image: url(" + escape(require("./images/shape1.svg")) + ");\n}\n\n.Shape__shape___12KOE.Shape__blue___10swc {\n  background-image: url(" + escape(require("./images/shape.svg")) + ");\n}", ""]);

// exports
exports.locals = {
	"shape": "Shape__shape___12KOE",
	"grey": "Shape__grey___3tqYF",
	"blue": "Shape__blue___10swc"
};